import { IsNotEmpty, IsNumber, IsString } from 'class-validator';

export class CreateUserAssetDto {
    @IsString()
    @IsNotEmpty()
    readonly name!: string;

    @IsString()
    @IsNotEmpty()
    readonly metadata!: string;

    @IsString()
    @IsNotEmpty()
    readonly description!: string;

    @IsNumber()
    @IsNotEmpty()
    readonly part!: number;

    @IsString()
    @IsNotEmpty()
    readonly userId!: string;
}
